/**
 * Unidad en la que esta REALMENTE guardado `line.quantity` en una linea que referencia un
 * material (regla 26). Mismo criterio que `quantityUnitOf` del POS
 * (pos/src/app/services/abc/abc.ts), que es quien descuenta el inventario:
 *
 * - `base` (recetas de menu `recipe[]` y desechables): con `input_quantity` o `presentation`
 *   (formato actual) la cantidad esta en la base de la **copia embebida** `line.material.metric`,
 *   no en la del catalogo — difieren si la unidad del material se cambio despues de guardar.
 *   Sin ninguno de los dos (legado) esta en `line.metric`. Los desechables no traen ni
 *   `metric` ni `input_quantity`, asi que caen a la base de la copia.
 * - `metric` (semielaborados, recetas de muestra, opciones de modificador): en `line.metric`.
 *
 * Sin dependencias a proposito: la comparten pantallas de reportes, disponibilidad y conteo.
 */
export function recipeLineQuantityUnit(line: any, convention: 'base' | 'metric'): string {
    const snapshotUnit: string = line?.material?.metric?.symbol || '';
    const lineUnit: string = line?.metric?.symbol || '';

    if (convention === 'base' && (line?.presentation || line?.input_quantity != null)) {
        return snapshotUnit || lineUnit;
    }

    return lineUnit || snapshotUnit;
}
